export const CONSTANTS = {
  PAYMENT_LINK:
    'https://elrincondigital.click/checkouts/cn/hWNAzW93W6jZrSqXJzyyzxjO/es-ar?_r=AQAB0naS3Ss3gadlYdEm0wwbRiW-0dBNGEhXWscDcwxf7Fg&preview_theme_id=154785841310',
  PREMIUM_PAYMENT_LINK:
    'https://elrincondigital.click/checkouts/cn/hWNBYudvq2xAVVmf5Agy23Mo/es-ar?_r=AQAB7zTMP2YC3TTpdxH5V26VQOhKzgXq2ER_O8js9UA53WI&preview_theme_id=154785841310',
  META_PIXEL_ID: '1225428543097695',
  PRODUCT_IMAGE:
    'https://cdn.magicpatterns.com/uploads/mB8tZZcngCfFML91EeeiTX/ChatGPT_Image_13_abr_2026,_18_15_48.png',
  PRICES: {
    ORIGINAL: '$30.990',
    SALE: '$19.990',
    SAVINGS: '35%',
    PREMIUM_SALE: '$24.990',
    CURRENCY: 'ARS',
  },
  COUNTDOWN_START_SECONDS: 643, // 00:10:43
  PURCHASE_NAMES: [
    { name: 'Mariana López', city: 'Buenos Aires' },
    { name: 'Sebastián Rodríguez', city: 'Córdoba' },
    { name: 'Valeria Fernández', city: 'Rosario' },
    { name: 'Nicolás García', city: 'Mendoza' },
    { name: 'Carolina Pérez', city: 'La Plata' },
    { name: 'Daniela Martínez', city: 'Mar del Plata' },
    { name: 'Lucas Gómez', city: 'Salta' },
    { name: 'Florencia Castro', city: 'San Miguel de Tucumán' },
    { name: 'Martín Silva', city: 'Bahía Blanca' },
    { name: 'Antonella Romero', city: 'Neuquén' },
    { name: 'Diego Morales', city: 'Santa Fe' },
    { name: 'Camila Torres', city: 'San Juan' },
  ],
}
